/**
 *  @project ICoFR PJB
 *  @author Ian Maulana on Tuesday, 20. August 2019
 *  @email ian_maulana@yahoo.com
 *  @description Abstract service
 */

/**
 * @typedef {Service}
 */
export default class BaseService {
  /**
   * @param {*} options
   */
  constructor (options) {
    this.options = options
  }

  /**
   * @param {*} options
   */
  static build (options) {
    return new this(options)
  }
}
